<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    primary?: boolean
    secondary?: boolean
    disabled?: boolean
    adaptive?: 'block' | string
    size?: 'md' | 'lg' | string
    href?: string
    tag?: 'button' | 'a'
  }>(),
  {
    size: 'lg',
    tag: 'button',
  },
)

const isLink = computed(() => props.tag === 'a' || !!props.href)

const classes = computed(() => [
  'btn',
  'rounded',
  'transition',
  'duration-400',
  {
    'btn-primary': props.primary,
    'btn-transp hover:bg-gray-100 border-gray-500':
      props.secondary || !props.primary,
    'hover:opacity-90': props.primary,
    disabled: props.disabled,
  },
])
</script>

<template>
  <a v-if="isLink" :href="href || '#'" :class="classes">
    <slot />
  </a>
  <button v-else :disabled="disabled" :class="classes" type="button">
    <slot />
  </button>
</template>
